function setupFilters() {
   var checkbox = document.querySelector("input[name=available-now-filter]");
   checkbox.addEventListener('change', function () {

      var urlParams = new URLSearchParams(window.location.search);

      if (this.checked) {
         console.log("Filtered for available now items..");
         document.querySelector('.collection__window').classList.remove('listing');
         document.querySelector('.collection__window').classList.add('available-now');
         urlParams.set('available', 'true');
      } else {
         console.log("Unfiltered for available now items..");
         document.querySelector('.collection__window').classList.add('listing');
         document.querySelector('.collection__window').classList.remove('available-now');
         urlParams.set('available', 'false');
      }

      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + urlParams.toString();
      window.history.pushState({ path: newurl }, '', newurl);

   });

   var urlParams = new URLSearchParams(window.location.search);
   Array.from(urlParams).forEach((param) => {
      if (param[0] == "available" && param[1] == 'true') {
         checkbox.checked = true;
         document.querySelector('.collection__window').classList.remove('listing');
         document.querySelector('.collection__window').classList.add('available-now');
      }
      if (param[0] == 'sort_by') {
         var filter = document.querySelector('#sort-items');
         filter.value = param[1];
         var label = document.querySelector('label[for="sort"]');
         label.innerHTML = 'Sort by: ' + filter.options[filter.selectedIndex].text;
      }
      if (param[0].substring(0, 6) == 'filter') {
         var filter = document.querySelector('select[name="' + param[0] + '"]');
         filter.value = param[1];
         var label = document.querySelector('label[for="' + param[0] + '"]');
         label.innerHTML = filter.options[filter.selectedIndex].text;

      }
   });

   var filters = document.querySelectorAll(".filter-item select");
   Array.from(filters).forEach((el) => {
      el.addEventListener('change', function () {
         if (el.value != el.id) {
            console.log('Filtering for ' + el.value);
            updateFilterSelection(el.getAttribute('data-param-name'), el.value);
            window.applyFilters();
         } else {
            clearFilters(el.getAttribute('data-param-name'));
            console.log('Clear filter');
            window.applyFilters();
         }
         var filterParam = el.getAttribute('name');
         var label = document.querySelector('label[for="' + filterParam + '"]');
         label.innerHTML = el.value;
      });
   }); 

   var sortItems = document.querySelector('#sort-items');
   sortItems.addEventListener('change', function () {
      sortResults(sortItems.value);
      window.applyFilters();
      var label = document.querySelector('label[for="sort"]');
      label.innerHTML = 'Sort by: ' + sortItems.options[this.selectedIndex].text;
   });

   function updateFilterSelection(param, value) {
      filterItems = document.querySelectorAll('input[name="' + param + '"]');
      Array.from(filterItems).forEach((el) => {
         el.checked = false;
      });
      document.querySelector('input[name="' + param + '"][value="' + value + '"]').checked = true;
   }
   function clearFilters(param) {
      filterItems = document.querySelectorAll('input[name="' + param + '"]');
      Array.from(filterItems).forEach((el) => {
         el.checked = false;
      });
   }
   function sortResults(value) {
      document.querySelector('input[name="sort_by"][value="' + value + '"]').checked = true;
   }
}

if(document.readyState !== 'loading') {
   setupFilters();
}
else {
   document.addEventListener('DOMContentLoaded', function () {
      setupFilters()
   });
}

function fallbackImage(image,src) {
   image.setAttribute('src', src);
}